var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-overlay",
    { staticClass: "row bg-white ", attrs: { show: _vm.loading } },
    [
      _vm.showNoImageAlert
        ? _c(
            "div",
            { staticClass: "col-12" },
            [
              _c(
                "b-alert",
                {
                  staticClass: "col-12 pt-5 pb-5 pl-3",
                  attrs: { variant: "warning", show: "" }
                },
                [
                  _c("feather-icon", {
                    staticClass: "mr-2",
                    attrs: { icon: "AlertCircleIcon" }
                  }),
                  _vm._v(" Lote no cuenta con imágenes ")
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "col-4" },
        [
          _c("UploadFile", {
            attrs: {
              permission: "ED188",
              text: "Seleccionar imagen",
              accept: ".jpg,.png",
              "max-size-in-mb": 30,
              "upload-to": _vm.urlFile,
              "button-class": "btn-block",
              "container-class": "w-100"
            },
            on: {
              input: function($event) {
                return _vm.addAdditionalFile()
              }
            },
            model: {
              value: _vm.additionalImage,
              callback: function($$v) {
                _vm.additionalImage = $$v
              },
              expression: "additionalImage"
            }
          })
        ],
        1
      ),
      _vm.newImages.length
        ? _c("div", { staticClass: "col-12 mt-3" }, [
            _c("h5", [_vm._v("Imágenes nuevas")]),
            _vm.newImages.length
              ? _c(
                  "div",
                  { staticClass: "mt-3" },
                  [
                    _c(
                      "b-table-simple",
                      { attrs: { hover: "", small: "" } },
                      [
                        _c(
                          "b-thead",
                          [
                            _c(
                              "b-tr",
                              [
                                _c("b-th", { attrs: { scope: "col" } }, [
                                  _vm._v("Nombre archivo")
                                ]),
                                _c(
                                  "b-th",
                                  {
                                    staticClass: "text-center",
                                    attrs: { scope: "col" }
                                  },
                                  [_vm._v("-")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm.newImages.length
                          ? _c(
                              "b-tbody",
                              _vm._l(_vm.newImages, function(file) {
                                return _c(
                                  "b-tr",
                                  { key: file.id },
                                  [
                                    _c("b-td", [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-items-center"
                                        },
                                        [
                                          _c("vs-icon", {
                                            staticClass: "mr-1",
                                            attrs: {
                                              icon: "file_present",
                                              size: "medium"
                                            }
                                          }),
                                          _vm._v(" " + _vm._s(file.name) + " ")
                                        ],
                                        1
                                      )
                                    ]),
                                    _c(
                                      "b-td",
                                      { staticClass: "text-center" },
                                      [
                                        _c(
                                          "b-button",
                                          {
                                            directives: [
                                              {
                                                name: "has-permission",
                                                rawName: "v-has-permission",
                                                value: "ED189",
                                                expression: "'ED189'"
                                              }
                                            ],
                                            attrs: {
                                              size: "sm",
                                              variant: "outline-danger"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.removeNewFile(
                                                  file.id
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v(" remover ")]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              }),
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "text-right" },
              [
                _c(
                  "b-button",
                  {
                    directives: [
                      {
                        name: "has-permission",
                        rawName: "v-has-permission",
                        value: "ED190",
                        expression: "'ED190'"
                      }
                    ],
                    staticClass: "mr-2",
                    attrs: { variant: "outline-secondary" },
                    on: {
                      click: function($event) {
                        return _vm.saveNewImages()
                      }
                    }
                  },
                  [_vm._v(" Agregar imágenes ")]
                )
              ],
              1
            )
          ])
        : _vm._e(),
      _vm.batchImages.length
        ? _c(
            "div",
            { staticClass: "col-12 mt-3" },
            [
              _c(
                "b-table-simple",
                { attrs: { hover: "", small: "" } },
                [
                  _c(
                    "b-thead",
                    [
                      _c(
                        "b-tr",
                        [
                          _c("b-th", { attrs: { scope: "col" } }, [
                            _vm._v("Nombre archivo")
                          ]),
                          _c("b-th", { attrs: { scope: "col" } }, [
                            _vm._v("Principal")
                          ]),
                          _c("b-th", { attrs: { scope: "col" } }, [
                            _vm._v("Preview")
                          ]),
                          _c(
                            "b-th",
                            {
                              staticClass: "text-center",
                              attrs: { scope: "col" }
                            },
                            [_vm._v("acciones")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.batchImages.length
                    ? _c(
                        "b-tbody",
                        _vm._l(_vm.batchImages, function(file) {
                          return _c(
                            "b-tr",
                            { key: file.imagenId },
                            [
                              _c("b-td", [
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip",
                                        value: "Principal",
                                        expression: "'Principal'"
                                      }
                                    ],
                                    staticClass: "d-flex align-items-center"
                                  },
                                  [_vm._v(" " + _vm._s(file.nombre) + " ")]
                                )
                              ]),
                              _c(
                                "b-td",
                                { staticClass: "text-center" },
                                [
                                  _c("vs-checkbox", {
                                    staticClass: "ml-5 pl-5",
                                    on: {
                                      change: function($event) {
                                        return _vm.markPrincipalImage(file)
                                      }
                                    },
                                    model: {
                                      value: file.principal,
                                      callback: function($$v) {
                                        _vm.$set(file, "principal", $$v)
                                      },
                                      expression: "file.principal"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c("b-td", { staticClass: "text-center" }, [
                                _c("img", {
                                  staticClass: "cursor-pointer img-batch",
                                  attrs: { src: file.urlImagen, alt: "image" }
                                })
                              ]),
                              _c(
                                "b-td",
                                { staticClass: "text-center" },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        size: "sm",
                                        variant: "outline-danger"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.removeAdditionalFile(
                                            file.imagenId
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v(" remover ")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        }),
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "col-12 text-right" },
        [
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "has-permission",
                  rawName: "v-has-permission",
                  value: "ED190",
                  expression: "'ED190'"
                }
              ],
              staticClass: "mr-2",
              attrs: { variant: "outline-secondary" },
              on: {
                click: function($event) {
                  return _vm.saveImages()
                }
              }
            },
            [_vm._v(" Guardar ")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }